import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AboutScreen.css';

export const AboutScreen = () => {
    const navigate = useNavigate();

    return (
        <div className="about-screen-modern">
            {/* Header */}
            <div className="about-header-nav">
                <button className="back-btn-about" onClick={() => navigate(-1)}>
                    <span className="material-icons">arrow_back</span>
                </button>
                <h1 className="about-title-nav">ABOUT NEXTRON</h1>
            </div>

            <div className="about-scroll-content">
                {/* Hero Banner */}
                <div className="about-hero-banner">
                    <h2 className="hero-brand-name">NEXTRON</h2>
                    <p className="hero-brand-tagline">ENERGY FOR THE FUTURE</p>
                </div>

                {/* Our Story */}
                <div className="about-story-card">
                    <div className="story-title-row">
                        <span className="material-icons story-icon">domain</span>
                        <h3 className="story-title">OUR STORY</h3>
                    </div>
                    <p className="story-text">
                        NEXTRON is a pioneering global technology investment firm established in 2018. We specialize in financing large-scale renewable energy infrastructure and cutting-edge digital transformation projects. Our platform allows retail investors to participate in high-yield industrial ventures previously reserved for institutional giants. Headquartered in a high-tech hub, we manage over $500M in sustainable assets across three continents, ensuring a greener future and steady returns for our partners.
                    </p>
                </div>

                {/* Feature Cards Grid */}
                <div className="about-features-row">
                    <div className="about-feature-card">
                        <div className="about-feature-icon-box">
                            <span className="material-icons">shield</span>
                        </div>
                        <h4 className="about-feature-title">SECURE CAPITAL</h4>
                        <p className="about-feature-desc">MULTI-LAYER ENCRYPTION FOR ALL INVESTMENTS</p>
                    </div>
                    <div className="about-feature-card">
                        <div className="about-feature-icon-box green">
                            <span className="material-icons">eco</span>
                        </div>
                        <h4 className="about-feature-title">SUSTAINABLE</h4>
                        <p className="about-feature-desc">FOCUS ON 100% RENEWABLE ENERGY PROJECTS</p>
                    </div>
                </div>

                {/* Global Impact */}
                <div className="global-impact-card">
                    <h3 className="impact-main-title">GLOBAL IMPACT</h3>
                    <div className="impact-stats-list">
                        <div className="impact-stat-item">
                            <span className="impact-stat-label">TOTAL USERS</span>
                            <span className="impact-stat-value">1.5 Million+</span>
                        </div>
                        <div className="impact-stat-item">
                            <span className="impact-stat-label">PROJECT REVENUE</span>
                            <span className="impact-stat-value">$840M+</span>
                        </div>
                        <div className="impact-stat-item">
                            <span className="impact-stat-label">CARBON OFFSET</span>
                            <span className="impact-stat-value">12K Tons/yr</span>
                        </div>
                    </div>
                </div>

                {/* Office Address */}
                <div className="office-footer">
                    <p className="office-address">
                        REGISTERED OFFICE: MARINA BAY FINANCIAL CENTRE, TOWER 3, SINGAPORE 018984
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AboutScreen;
